import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { beforeItems, withRouteItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-78" data-mp="26luonyxbie5l">
      <div className="mx-auto w-full max-w-5xl px-5" data-id="element-79" data-mp="26k9ysmly7je2">
        <p className="text-center text-[0.7rem] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-80" data-mp="22lspbwf21wth">
          Before vs. With Clinical Route for Erectile Dysfunction™
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-center font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-81" data-mp="2ubfe90nz89nu">
          The same consultation, approached two very different ways.
        </h2>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-82" data-mp="2laqv5rjq7j43">
          <div className="rounded-3xl border border-rose-200 bg-rose-50 p-5 sm:p-6" data-id="element-83" data-mp="1evq0rqacn8zm">
            <h3 className="flex items-center gap-2 font-display text-lg font-extrabold uppercase tracking-tight text-rose-700" data-id="element-84" data-mp="19wdbkyw09ptv">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-rose-600" data-id="element-85" data-mp="176ff6ghtgq1m">
                <XIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-86" data-mp="1c3e7cthx6mx6" />
              </span>
              Before
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-87" data-mp="y4eef9ndjlv7">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white px-4 py-3.5 text-[0.92rem] leading-relaxed text-slate-700 ring-1 ring-rose-100" data-id="element-88" data-mp="1327owevpn21a">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-500" aria-hidden="true" data-id="element-89" data-mp="t7fpd5iki53v" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border border-emerald-200 bg-emerald-50 p-5 sm:p-6" data-id="element-90" data-mp="5fqtjf6jeyi6">
            <h3 className="flex items-center gap-2 font-display text-lg font-extrabold uppercase tracking-tight text-emerald-700" data-id="element-91" data-mp="afd39en5pwm8">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-600" data-id="element-92" data-mp="2c5u121nam0c0">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-93" data-mp="27bzjp4v5txg3" />
              </span>
              With the Clinical Route
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-94" data-mp="1yde7drga7enr">
              {withRouteItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white px-4 py-3.5 text-[0.92rem] leading-relaxed text-slate-700 ring-1 ring-emerald-100" data-id="element-95" data-mp="2v2v9jwg22ikp">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-96" data-mp="2m1dxqq9ol31t" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-97" data-mp="15ogphpfzfjvj">
          <CTAButton label="I want to work this way from day one" note="Immediate access · One-time payment" data-id="element-98" data-mp="15mm3e7sz5lpv" />
        </div>
      </div>
    </section>;
}